/**
 * @generated SignedSource<<cd551a2562f6ec0f1382f9a208ab6e30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetInternalDocumentSetForFilesMutationInput = {
  clientMutationId?: string | null;
  fileIds: ReadonlyArray<string | null>;
  internalDocumentSetId: string;
};
export type UploadInternalDocumentsSetInternalDocumentSetForFilesMutation$variables = {
  input: SetInternalDocumentSetForFilesMutationInput;
};
export type UploadInternalDocumentsSetInternalDocumentSetForFilesMutation$data = {
  readonly setInternalDocumentSetForFiles: {
    readonly success: boolean | null;
  } | null;
};
export type UploadInternalDocumentsSetInternalDocumentSetForFilesMutation = {
  response: UploadInternalDocumentsSetInternalDocumentSetForFilesMutation$data;
  variables: UploadInternalDocumentsSetInternalDocumentSetForFilesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetInternalDocumentSetForFilesMutationPayload",
    "kind": "LinkedField",
    "name": "setInternalDocumentSetForFiles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadInternalDocumentsSetInternalDocumentSetForFilesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadInternalDocumentsSetInternalDocumentSetForFilesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0defc264b7ac02a0679ea7844eae0ff5",
    "id": null,
    "metadata": {},
    "name": "UploadInternalDocumentsSetInternalDocumentSetForFilesMutation",
    "operationKind": "mutation",
    "text": "mutation UploadInternalDocumentsSetInternalDocumentSetForFilesMutation(\n  $input: SetInternalDocumentSetForFilesMutationInput!\n) {\n  setInternalDocumentSetForFiles(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c32bb9627c6277cf79a8b2c2fa16ed9";

export default node;
